// =============================================================================
// SIREPPAR - "Portero" de /expedientes/:id
// =============================================================================
// La lista general de Expedientes linkea acá para CUALQUIER tipo de trámite.
// Reempadronamiento, Reconocimiento, Rendiciones y Candidaturas se resuelven con
// la pantalla genérica de siempre (ExpedienteDetailPage, que ya soporta el tipo
// CANDIDATURA). El personal interno sí tiene su propia pantalla de candidaturas
// (documentación, stepper y tabs distintos) — así que antes de renderizar la
// genérica, se consulta si este expediente tiene un candidato asociado:
//   - usuario interno   -> vista interna de candidaturas
//   - apoderado externo -> pantalla genérica de expediente (igual que los demás trámites)
// Si no hay candidato asociado, es un expediente de otro tipo y se deja pasar
// a la pantalla genérica, sin ningún cambio de comportamiento.
// =============================================================================

import { useParams, Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../contexts/AuthContext';
import { candidatoService } from '../../services/api';
import ExpedienteDetailPage from './ExpedienteDetailPage';

const ROLES_INTERNOS = ['ADMINISTRADOR', 'SUPERVISOR', 'AUTORIDAD_FIRMANTE', 'MESA_ENTRADAS', 'ANALISTA', 'AUDITOR'];

export default function ExpedienteOCandidaturaGate() {
  const { id } = useParams<{ id: string }>();
  const { user } = useAuth();
  const esInterno = ROLES_INTERNOS.includes(user?.rol || '');

  const { data, isLoading } = useQuery({
    queryKey: ['candidato-por-expediente', id],
    queryFn: async () => (await candidatoService.obtenerPorExpediente(id!)).data.data,
    enabled: !!id,
  });

  if (isLoading) {
    return (
      <div className="p-6 flex items-center justify-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (data?.id && esInterno) {
    return <Navigate to={`/candidaturas/gaiman/expedientes/${id}`} replace />;
  }

  return <ExpedienteDetailPage />;
}
